import { NONE } from "../../../consts/strings";
import {
  CHOICE_DRIVER_TYPE,
  ROBOT_DRIVER_TYPE,
} from "../../../consts/driverTypes";
import { palette } from "../../../theme/palette";

import ChoiceDriverMarker from "../../ChoiceDriverMarker";
import RobotDriverMarker from "../../RobotDriverMarker";
import { Text, View } from "../../Base";

export const WorkScheduleDayAutocompleteNoneMenuItem = ({
  isHighlighted,
  isSelected,
  onMouseEnter,
}) => {
  const highlightStyle = {};
  if (isHighlighted) highlightStyle.backgroundColor = palette.veryLightGrey;
  else if (isSelected) highlightStyle.backgroundColor = palette.lightGrey;
  return (
    <View
      key={NONE}
      style={{
        padding: "0.25rem 0.75rem",
        ...highlightStyle,
      }}
      onMouseEnter={onMouseEnter}
    >
      <Text>{NONE}</Text>
    </View>
  );
};

export const WorkScheduleDayAutocompleteMenuItem = ({
  isHighlighted,
  isSelected,
  onMouseEnter,
  driverCode,
  driverName,
  routeCode,
  workingDays,
  driverType,
}) => {
  const highlightStyle = {};
  if (isHighlighted) highlightStyle.backgroundColor = palette.veryLightGrey;
  else if (isSelected) highlightStyle.backgroundColor = palette.lightGrey;
  return (
    <View
      key={driverCode}
      style={{
        padding: "0.25rem 0.75rem",
        flex: 1,
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        ...highlightStyle,
      }}
      onMouseEnter={onMouseEnter}
    >
      {driverType === CHOICE_DRIVER_TYPE && <ChoiceDriverMarker />}
      {driverType === ROBOT_DRIVER_TYPE && <RobotDriverMarker />}
      <View style={{ flex: 1, marginRight: "5px" }}>
        <Text>
          {`(${driverCode.split("*")[1]}) - ${
            routeCode || NONE
          } - ${driverName} - ${workingDays.join(", ")}`}
        </Text>
      </View>
    </View>
  );
};
